import { render, staticRenderFns } from "./colorPickers.vue?vue&type=template&id=c6058aa4&scoped=true"
import script from "./colorPickers.vue?vue&type=script&lang=js"
export * from "./colorPickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6058aa4",
  null
  
)

export default component.exports